import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { changeColor } from '../../actions/project/border'
import CollectionColors from '../../components/CollectionColors'
import findColor from './findColor'

const mapStateToProps = state => ({
  colors: findColor(
    dotProp.get(state, 'frames.frames', []),
    dotProp.get(state, 'frames.current', { width: 0, height: 0 })
  ),
  isLoading: dotProp.get(state, 'frames.isLoading', false),
  errMessage: dotProp.get(state, 'frames.errMessage', ''),
})

const mapDispatchToProps = dispatch => ({
  onClick: color => dispatch(changeColor(color)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollectionColors)



// WEBPACK FOOTER //
// ./src/containers/CollectionColors/index.js